export const PRIORITY_HIGH = 1;
export const PRIORITY_MEDIUM = 2;
export const PRIORITY_LOW = 3;

export const METADATA_PRIORITIES = {
    [PRIORITY_HIGH]: {
        name: 'High',
    },
    [PRIORITY_MEDIUM]: {
        name: 'Medium',
    },
    [PRIORITY_LOW]: {
        name: 'Low',
    }
};
